import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';

import { environment } from '../../../../environments/environment';
import { HasPermitDirective } from '../directives/has-permit.directive';

@NgModule({
  declarations: [HasPermitDirective],
  imports: [CommonModule],
  exports: [HasPermitDirective],
  providers: [
    // Inicialización del núcleo de Firebase/Identity Platform con las credenciales del entorno activo.
    provideFirebaseApp(() => initializeApp(environment.auth_environment.FIREBASE)),

    // Habilita el motor de autenticación (Firebase Auth), pivote de la federación con Keycloak.
    provideAuth(() => getAuth()),
  ]
})
export class CoreAuthModule { }
